import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from './data.service';
import { ReportViewer } from '../model/report-viewer';
import { OrientationPatientSearchItem } from '../model/orientation/orientation-patient-search-item';

@Injectable({
  providedIn: 'root'
})
export class OrientationService {

  constructor(private http: HttpClient, private dataService: DataService) { }
  private readonly getOrientationAdmissionReportPdfEndPoint: string = '/orientation/getOrientationAdmissionReportPdf/';
  private readonly getOrientationReservationReportPdfEndPoint: string = '/orientation/getOrientationReservationReportPdf/';
  private readonly getDeliveryReportPdfEndPoint: string = '/orientation/getDeliveryReportPdf/';
  private readonly getOrientationPatientSearchItemEndPoint: string = '/orientation/getOrientationPatientSearchItem/';
  private readonly callOrientationPatientEndPoint: string = '/orientation/callOrientationPatient/';

  async getOrientationPatientSearchItem(sectorId: number): Promise<OrientationPatientSearchItem[]> {
    const params = { sectorId: sectorId };
    return await this.dataService.get<OrientationPatientSearchItem[]>(this.getOrientationPatientSearchItemEndPoint, params).toPromise();
  }

  async callOrientationPatient(
    id: number,
    sectorId: number,
    workstation: string): Promise<boolean> {

    const params = {
      Id: id,
      SectorId: sectorId,
      workstation: workstation
    };

    return await this.dataService.post<boolean>(this.callOrientationPatientEndPoint, params).toPromise();
  }

  async getOrientationAutomaticAdmissionReportPdf(
    orientationId: number,
    turnoId: number): Promise<ReportViewer> {

    const params = {
     orientationId: orientationId,
     turnoId: turnoId,
    };

    return await this.dataService.get<ReportViewer>('/orientation/getOrientationAutomaticAdmissionReportPdf/', params).toPromise();
  }

  async getOrientationAdmissionReportPdf(
    orientationId: number,
    discapacitado: boolean,
    document: number,
    patientId?: number,
    serviceId?: number): Promise<ReportViewer> {

     const params = {
      orientationId: orientationId,
      discapacitado: discapacitado,
      document: document,
      patientId: patientId,
      serviceId: serviceId
     };

     return await this.dataService.get<ReportViewer>(this.getOrientationAdmissionReportPdfEndPoint, params).toPromise();
  }

  async getOrientationReservationReportPdf(
    orientationId: number,
    discapacitado: boolean,
    document: number,
    patientId?: number,
    serviceId?: number): Promise<ReportViewer> {

      const params = {
       orientationId: orientationId,
       discapacitado: discapacitado,
       document: document,
       patientId: patientId,
       serviceId: serviceId
      };

      return await this.dataService.get<ReportViewer>(this.getOrientationReservationReportPdfEndPoint, params).toPromise();
  }

  async getDeliveryReportPdf(
    orientationId: number,
    discapacitado: boolean,
    document: number,
    patientId?: number,
    serviceId?: number): Promise<ReportViewer> {

    const params = {
     orientationId: orientationId,
     discapacitado: discapacitado,
     document: document,
     patientId: patientId,
     serviceId: serviceId
    };

    return await this.dataService.get<ReportViewer>(this.getDeliveryReportPdfEndPoint, params).toPromise();
  }
}
